import headers from '../headers/headerTable'
export default [
    {
        name: 'invoice_type',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Tipo Documento',
        },
    },
    {
        name: 'invoice_number',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Folio Documento',
        },
    },
    {
        name: 'net_total',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Neto',
            reverse: true,
        },
    },
    {
        name: 'iva',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'IVA',
            reverse: true,
        },
    },
    {
        name: 'total',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total',
            reverse: true,
        },
    },
    {
        name: 'global_discount_percentage',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Dto. Global',
            suffix: '%',
        },
    },
    {
        name: 'global_discount_amount',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Dto. Global',
        },
    },
    {
        name: 'sl_detail_sale_invoices',
        type: 'table-field',
        flex: {
            xs12: true,
            'd-grid': true,
        },
        props: {
            toolbarTitle: 'Detalle de productos de factura',
            headers,
        },
    },
]
